/**
 * @prop --color: Status color text
 */

:host {
  --color: #{$baseColor};
  --min-width: none;

  &[with-loadingbar]:not([with-loadingbar="false"]) {
    --min-width: 160px;
  }

  &[type="success"] {
    --color: #{$colorSuccess70};
  }

  &[type="warning"] {
    --color: #{$colorWarning90};
  }

  &[type="error"] {
    --color: #{$colorError70};
  }

  &[type="info"] {
    --color: #{$colorMidnightblue70};
  }
}

.stzh-status {
  min-width: var(--min-width);
  color: var(--color);

  &__dot {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    background-color: currentColor;
    margin-right: space('xxsmall');
  }

  &__bar {
    display: block;
    height: 4px;
    border-radius: 12px;
    background-color: $colorOldGrey13;
    margin-top: space('xxsmall');
  }

  &__bar-inner {
    display: block;
    height: 100%;
    width: 0;
    border-radius: 12px;
    background: currentColor;
  }

  &__text {
    @include fontSize('micro');
    display: flex;
    align-items: center;
  }
}
